/**
 * Maps a `/invite/get` LOOKUP-step error code to the inline sentence the
 * preview dialog shows. A failed `POST /invite/accept` or
 * `POST /invite/decline` is a committed action, not a lookup, and goes
 * through `showApiError` / `showOfflineError` instead (see the plan's
 * `## 5.7`). This module has no branch for either of those failures and must
 * never gain one.
 */

export function inviteLookupErrorCopy(code: string | null | undefined): string {
  switch (code) {
    case "NOT_FOUND":
    case "VALIDATION_ERROR":
      return "We couldn't find that invite. It may have been taken back.";
    default:
      return "Something went wrong. Try again in a moment.";
  }
}

export const INVITE_OFFLINE_MESSAGE =
  "You're offline. Check your connection and try again.";

export const INVITE_LIST_FAILED_MESSAGE = "We could not load your invites.";
